import { log } from "../../utils";
import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";
import { writeMessage } from "./writeMessage";

export default function executeAction(text: string, token?: string): ChatServerAsyncActionType {
    return chatServer => (dispatch, getState) => {
        let attributes = getState().attributes;
        attributes = { ...attributes, currentUrl: window.location.href };

        chatServer.sendChatMsg({ text, token, attributes }, (err?: Error) => {
            if (err) {
                log("Error sending message", err);
                return;
            }
        });

        const visitor = getState().visitor;
        dispatch(writeMessage({
            text: !token ? text : `${text} (from the list)`
        }, visitor));
    }
}